var ko = {};
module['exports'] = ko;
ko.title = "Korean";
ko.address = require("./address");
ko.phone_number = require("./phone_number");
ko.company = require("./company");
ko.internet = require("./internet");
ko.lorem = require("./lorem");
ko.name = require("./name");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ko/index.js
// module id = 1490
// module chunks = 1